.searchResultsView {
  .phone &,
  .tablet & {
    height: 100%;
  }

  .resultsBlock {
    padding: 32px 24px;
    max-height: 495px;
    overflow: auto;
    scrollbar-color: #28272a var(--primitives-colors-neutral-980);
    clip-path: inset(0 round 14px);

    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      visibility: hidden;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background: rgb(255, 255, 255, 0.2);
    }

    &::-webkit-scrollbar:window-inactive {
      visibility: hidden;
    }

    .phone &,
    .tablet & {
      max-height: calc(100% - 161px);
      padding: 24px 16px 32px;
      clip-path: none;
    }
  }

  .noResults {
    margin-top: 16px;
  }
}